/* unplugin-vue-components disabled */import { render } from "./SvgIcon.vue?vue&type=template&id=16172836&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=16172836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16172836"]])

export default __exports__